<template>
  <el-container>
    <el-header class="nav-top">
      <span class="fl"><img src="../assets/logo.png" style="margin-top: 14px"></span>
      <div class="fr" style="cursor: pointer">
        <img src="#">
        <el-dropdown>
          <span class="el-dropdown-link" style="font-weight: bold;color: #333;font-size: 16px">
            {{username}}<i class="qb-icon-sanjiaoxiala1 el-icon--right" style="font-size: 12px"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button type="text" @click="changePwd" style="background: none;color: #333">修改密码</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button style="background: none;">
                <a href="https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/images/help/helpa.pdf"
                   target="_Blank" style="text-decoration: none;color:#333;">操作手册</a>
              </el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="text" @click="goto" style="background: none;color: red">退出登录</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
      <el-container>
      <el-aside width="170px" style="padding: 30px 0 100px 0;">
        <el-menu :default-active="$route.path" :collapse="menuCollapsed" :router="true" :unique-opened="true" :class="rightMenu" style="border: none">
          <!--<el-submenu v-if="associationId ===1"  index="/sale" class="menu-list menu_shipin" popper-class="menu_list">-->
          <el-submenu v-if="associationId ===1"  index="/video" class="menu-list menu_shipin" popper-class="menu_list">
            <template slot="title" >
              <i class="qb-icon-shipin1"></i>
              <i class="blue_dot"></i>
              <span slot="title" >{{"视频管理"}}</span>
            </template>
            <el-menu-item index="/video/live">{{"直播"}}</el-menu-item>
            <el-menu-item index="/video/courseware">{{"优质课件"}}</el-menu-item>
            <el-menu-item index="/video/reply">{{"留言回复"}}</el-menu-item>
            <el-menu-item index="/video/classify">{{"分类管理"}}</el-menu-item>
          </el-submenu>
          <el-submenu index="/ow" class="menu-list menu_lvshi" popper-class="menu_list">
            <template slot="title">
              <i class="qb-icon-lvshiguanli"></i>
              <i class="blue_dot"></i>
              <span slot="title">{{"律师管理"}}</span>
            </template>
            <el-menu-item index="/lawyer/lawyer">{{"律师管理"}}</el-menu-item>
            <el-menu-item index="/lawyer/check">{{"律师审核"}}</el-menu-item>
            <el-menu-item v-if="associationId ===1"  index="/lawyer/association">{{"协会管理"}}</el-menu-item>
            <el-menu-item index="/lawyer/credit">{{"学分管理"}}</el-menu-item>
            <el-menu-item index="/lawyer/period">{{"学时管理"}}</el-menu-item>
          </el-submenu>
          <el-submenu v-if="associationId ===1"  index="/notice" class="menu-list" popper-class="menu_list">
            <template slot="title">
              <i class="qb-icon-qb-icon-tongzhi"></i>
              <i class="blue_dot"></i>
              <span slot="title">{{"通知公告"}}</span>
            </template>
            <el-menu-item index="/notice">{{"公告"}}</el-menu-item>
          </el-submenu>
          <el-submenu index="/service" v-if="username==='yxkj'|| username==='admin'" class="menu-list menu_reset" popper-class="menu_list">
            <template slot="title">
              <i class="qb-icon-xitongguanli1"></i>
              <i class="blue_dot"></i>
              <span slot="title">{{"系统管理"}}</span>
            </template>
            <el-menu-item index="/sys/user">{{"用户管理"}}</el-menu-item>
            <el-menu-item index="/sys/role">{{"角色管理"}}</el-menu-item>
            <el-menu-item index="/sys/resource">{{"资源管理"}}</el-menu-item>
            <el-menu-item index="/sys/permission">{{"权限管理"}}</el-menu-item>
            <el-menu-item index="/sys/cycleSet">{{"周期设置"}}</el-menu-item>
            <el-menu-item index="/sys/wechatMenu">{{"公众号菜单"}}</el-menu-item>
          </el-submenu>
          <el-submenu v-if="associationId ===1"  index="/log" class="menu-list" popper-class="menu_list">
            <template slot="title">
              <i class="qb-icon-rizhi1"></i>
              <i class="blue_dot"></i>
              <span slot="title">{{"系统日志"}}</span>
            </template>
            <el-menu-item index="/log/sysLog">{{"操作日志"}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <router-view/>
    </el-container>
    <el-dialog title="修改密码" :visible.sync="changeDialog">
      <el-form :model="userForm"  size="small" :rules="rules" ref="userForm" >
        <el-form-item label="用户名" label-width="70px">
          <el-input v-model="userForm.username" type="text"></el-input>
        </el-form-item>
        <el-form-item label="老密码" label-width="70px" prop="password">
          <el-input v-model="userForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width="70px" prop="newPwd">
          <el-input v-model="userForm.newPwd" type="password"></el-input>
        </el-form-item>
        <el-form-item label="请确认密码" label-width="70px" prop="confirmPwd">
          <el-input v-model="userForm.confirmPwd" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="cancel('userForm')">{{'取消'}}</el-button>
        <el-button type="primary" @click="save('userForm')">{{'确认'}}</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import login from '@/api/login'
import store from '../store/index'
import user from '@/api/user'
export default {
  name: 'Admin',
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入老密码'));
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.userForm.confirmPwd !== '') {
          this.$refs.userForm.validateField('confirmPwd');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.userForm.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userForm: {
        id: '',
        username: '',
        password: '',
        newPwd: '',
        confirmPwd: ''
      },
      username: '管理员',
      id: '',
      associationId: '',
      changeDialog: false,
      saleBtnClass: false,
      owBtnClass: false,
      noticeBtnClass: false,
      serviceBtnClass: false,
      syslogBtnClass: false,
      rules: {
        password: [
          { validator: validateOldPass, trigger: 'blur' }
        ],
        newPwd: [
          { validator: validatePass, trigger: 'blur' }
        ],
        confirmPwd: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    menuCollapsed() {
      return this.$store.getters.getMenuCollapsed || false
    },
    rightMenu() {
      return this.menuCollapsed ? 'right_menu' : 'right_menu_opened'
    },
    activeIndex() {
      return this.$route.path.replace('/', '')
    }
  },
  methods: {
    goto() {
      login.userlogout().then(res => {
        if (res.data.code === 0) {
          sessionStorage.clear()
          localStorage.clear()
          this.$message({
            type: 'info',
            message: '退出成功'
          });
        }
      })
      this.$router.push({path: '/login'})
    },
    changePwd() {
      //修改密码
      this.changeDialog = true
      this.userForm.username = this.username
      this.userForm.id = this.id
    },
    cancel () {
      this.changeDialog = false
      this.userForm = {}
    },
    save () {
      login.changePwd(this.userForm).then(res => {
        if (res.data.code===0) {
          this.$message({
            type: 'success',
            message: res.data.message
          });
          this.changeDialog =false
          this.userForm = {}
          this.goto()
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }
      })
    },
    toggleMenu() {
      this.$store.dispatch('menuCollapse', !this.menuCollapsed)
    },
    mouseEditClass (index) {
        this.btnClass = false
    },
  //   handleOpen (index, path) {
  //     this.saleBtnClass = false
  //     this.owBtnClass = false
  //     this.noticeBtnClass = false
  //     this.serviceBtnClass = false
  //     this.syslogBtnClass = false
  //     if (index.indexOf('sale') >= 0) {
  //       this.saleBtnClass = true
  //     } else if (index.indexOf('ow') >= 0) {
  //       this.owBtnClass = true
  //     } else if (index.indexOf('notice') >= 0) {
  //       this.noticeBtnClass = true
  //     } else if (index.indexOf('service') >= 0) {
  //       this.serviceBtnClass = true
  //     } else if (index.indexOf('syslog') >= 0) {
  //       this.syslogBtnClass = true
  //     }
  //   },
  //   handleClose (index, path) {
  //     this.saleBtnClass = false,
  //     this.owBtnClass = false,
  //     this.noticeBtnClass = false,
  //     this.serviceBtnClass = false,
  //     this.syslogBtnClass = false
  //   }
  },
  created() {
    if (this.$route.path === '/') {
      // this.$router.push({path: '/video/live'})
      this.$router.push({path: '/index'})
    }
    if (store.getters.getUsername) {
      this.username = store.getters.getUsername
    }
    if (store.getters.getUserId) {
      this.id = store.getters.getUserId
    }
    if (this.id!== null && this.id !== '') {
      user.findById({id: this.id}).then(res => {
        if (res.data.code===0) {
          this.associationId = res.data.data.associationId
          if (res.data.data.associationId === 1){
            // this.GlobalVariable.assId = null
            this.$store.dispatch('asId',null)
            // console.log('没存' + store.getters.getAsId)
          } else {
            // this.GlobalVariable.assId = res.data.data.associationId
            this.$store.dispatch('asId',res.data.data.associationId)
          }
        } else {
          this.associationId = ''
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin.vue